import { render, staticRenderFns } from "./view-form.vue?vue&type=template&id=4085903b&"
import script from "./view-form.vue?vue&type=script&lang=js&"
export * from "./view-form.vue?vue&type=script&lang=js&"
import style0 from "./view-form.vue?vue&type=style&index=0&id=4085903b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports